import { useTranslation } from 'react-i18next';
import grayHeart from 'public/static/images/favorites/gray-heart.svg';
import barChart from 'public/static/images/favorites/bar-chart.svg';
import styles from './styles';

export enum EmptyPageCardType {
  favorites,
  priceDrops,
}

interface EmptyPageCardProps {
  cardType: EmptyPageCardType;
}

const EMPTY_CARD_MAP = {
  [EmptyPageCardType.favorites]: {
    className: 'gray-heart-icon',
    image: grayHeart,
    title: 'favorites.noFavoritesTitle',
    text: 'favorites.noFavoritesText',
  },
  [EmptyPageCardType.priceDrops]: {
    className: 'bar-chart-icon',
    image: barChart,
    title: 'favorites.noPriceDropTitle',
    text: 'favorites.noPriceDropText',
  },
};

const EmptyPageCard = ({ cardType }: EmptyPageCardProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className="empty-card-container">
      <div className="empty-card">
        <img
          className={`empty-card-image ${EMPTY_CARD_MAP[cardType].className}`}
          src={EMPTY_CARD_MAP[cardType].image}
        />
        <div className={`empty-card-label`}>{t(EMPTY_CARD_MAP[cardType].title)}</div>
        <div className="empty-card-content">{t(EMPTY_CARD_MAP[cardType].text)}</div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default EmptyPageCard;
